import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { NewPanelPreferencePage } from '@/areas/settings/pcb/Settings/PcbPage/PanelPreferencePage';
import { canEditPanelPreferences } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/create')({
    staticData: {
        access: { permissions: canEditPanelPreferences },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <NewPanelPreferencePage />;
}
